import JassEnum from './enum';

/**
 * type mapcontrol
 */
export default class JassMapControl extends JassEnum {}
